// ECAL brand tokens — from the 2026 Brand Guidelines (EcalWorldPrototype/src/styles.css)
export const ECAL = {
    navy:      '#010134',
    deepblue:  '#000082',
    midblue:   '#0078FF',
    lightblue: '#00D7FF',
    yellow:    '#FFDF10',
    orange:    '#FF9E00',
    dorange:   '#FF4D00',
    green:     '#00D456',
    white:     '#FFFFFF',
    midgrey:   '#777777',
    lightgrey: '#BBBCBC',
};

const fontFamily = [
    '"Google Sans Flex"',
    '"Google Sans"',
    'Inter',
    'ui-sans-serif',
    'system-ui',
    'Arial',
    'sans-serif',
].join(',');

const monoFamily = [
    '"Google Sans Code"',
    '"Fira Code"',
    '"Cascadia Code"',
    'ui-monospace',
    'monospace',
].join(',');

const defaultTokens = {
    // ECAL World is dark-first
    defaultColorScheme: 'dark',

    colorSchemes: {
        dark: {
            palette: {
                primary: {
                    main: ECAL.midblue,
                    light: ECAL.lightblue,
                    dark: ECAL.deepblue,
                    contrastText: ECAL.white,
                },
                secondary: {
                    main: ECAL.green,
                    light: ECAL.lightblue,
                    dark: ECAL.midblue,
                    contrastText: '#00270f',
                },
                warning: {
                    main: ECAL.orange,
                    light: ECAL.yellow,
                    dark: ECAL.dorange,
                    contrastText: '#1a0a00',
                },
                success: {
                    main: ECAL.green,
                    contrastText: '#00270f',
                },
                info: {
                    main: ECAL.lightblue,
                    contrastText: '#001025',
                },
                error: {
                    main: '#ff4d4f',
                },
                background: {
                    default: ECAL.navy,
                    paper: '#060638',
                },
                text: {
                    primary: ECAL.white,
                    secondary: ECAL.lightgrey,
                    disabled: ECAL.midgrey,
                },
                divider: 'rgba(187, 188, 188, 0.14)',
            },
        },

        light: {
            palette: {
                primary: {
                    main: ECAL.midblue,
                    light: ECAL.lightblue,
                    dark: ECAL.deepblue,
                    contrastText: ECAL.white,
                },
                secondary: {
                    main: ECAL.green,
                    contrastText: '#00270f',
                },
                warning: {
                    main: ECAL.orange,
                    contrastText: '#1a0a00',
                },
                background: {
                    default: '#f0f4ff',
                    paper: '#ffffff',
                },
                text: {
                    primary: ECAL.navy,
                    secondary: '#444466',
                },
                divider: 'rgba(1, 1, 52, 0.12)',
            },
        },
    },

    typography: {
        fontFamily,
        fontFamilyCode: monoFamily,
        h1: { fontSize: '2.5rem', fontWeight: 700, lineHeight: 0.95, letterSpacing: '-0.02em' },
        h2: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.1 },
        h3: { fontSize: '1.75rem', fontWeight: 600 },
        h4: { fontSize: '1.5rem', fontWeight: 600 },
        h5: { fontSize: '1.25rem', fontWeight: 600 },
        h6: { fontSize: '1rem', fontWeight: 600 },
        body1: { fontSize: '1rem', lineHeight: 1.6 },
        body2: { fontSize: '0.875rem', lineHeight: 1.5 },
        caption: { fontSize: '0.72rem', letterSpacing: '0.02em' },
        overline: { fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase' },
        button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
    },

    shape: {
        borderRadius: 22,   // matches .tile / .card from prototype
    },

    spacing: 8,
};

export default defaultTokens;
